<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">我的随手拍</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item> -->
        <el-form-item label="状态">
          <el-select v-model="formInline.check_status" clearable filterable placeholder="请选择状态">
            <el-option v-for="item in $store.state.freeStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择${$store.state.themeTitle}室名称`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column prop="training_room_name" :label="`${$store.state.themeTitle}室`" width="120">
        </custom-table-column>
        <custom-table-column  label="状态" width="100"  prop="check_status"  label-class-name="freeStatus" :formatter="format_arr" >
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.check_status=='0'" style="color:var(--blue);">登记</span>
            <span v-if="scope.row.check_status=='1'" style="color:var(--ligtGreen);">整改</span>
            <span v-if="scope.row.check_status=='2'" style="color:var(--red);">关闭</span>
          </template> -->
        </custom-table-column>
        <custom-table-column prop="check_form_name" label="检查表名" width="160">
        </custom-table-column>
        <custom-table-column prop="check_form_cate" label="检查分类" width="160">
        </custom-table-column>
        <custom-table-column prop="check_form_title" label="检查项目" width="160">
        </custom-table-column>
        <custom-table-column prop="check_form_content" label="检查标准" width="160">
        </custom-table-column>
        <custom-table-column prop="check_time" label="检查时间" width="160">
        </custom-table-column>
        <custom-table-column prop="check_desc" label="检查情况描述" min-width="220">
        </custom-table-column>
        <custom-table-column prop="score" label="分值" width="60">
        </custom-table-column>
        <custom-table-column prop="level" label="隐患级别" width="80">
        </custom-table-column>
        <custom-table-column prop="creator_name" label="创建人" width="160">
        </custom-table-column>
        <custom-table-column label="现场照片" min-width="240">
          <template slot-scope="scope" v-if="scope.row.file">
            <!-- <el-link type="primary" v-for="(item,index) in scope.row.file.split(',')" :href="item" :key="index" target="_blank">{{ $until.getFileName(item) }}</el-link> -->
            <el-image style="width: 100px; height: 100px" v-for="(item,index) in scope.row.file.split(',')" :key="index" :src="item" :preview-src-list="scope.row.file.split(',')">
            </el-image>
          </template>
        </custom-table-column>
        <!-- <custom-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.check_status=='0'" @click="handleOper(scope.row.id,'1')" type="text" size="small">整改</el-button>
            <el-button v-if="scope.row.check_status=='0'" @click="handleOper(scope.row.id,'2')" type="text" size="small">关闭</el-button>
          </template>
        </custom-table-column> -->
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteDeviceInto">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="详情" :visible.sync="detailDialogVisible" width="746px">
      <el-descriptions class="margin-top" title="" direction="vertical" :column="2"  border>
        <el-descriptions-item>
          <template slot="label">检查内容 </template> {{rowObj.name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">状态 </template>
          <span v-if="rowObj.rectify_status=='1'" style="color:var(--blue);">评估</span>
          <span v-if="rowObj.rectify_status=='2'" style="color:var(--ligtGreen);">整改</span>
          <span v-if="rowObj.rectify_status=='3'" style="color:var(--red);">验证</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">隐患等级 </template> {{rowObj.level}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">分值 </template> {{rowObj.score}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">整改期限 </template> {{rowObj.rectify_limit_date}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">附件 </template>
          <template v-if="rowObj.file">
            <el-link type="primary" v-for="(item,index) in rowObj.file.split(',')" :href="item" :key="index" target="_blank">{{ $until.getFileName(item) }}</el-link>
          </template>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">问题描述 </template> {{rowObj.desc}}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="operDialogVisible" width="530px">
      <el-form :model="ruleOperForm" :rules="operRules" ref="ruleOperForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="处理结果" placeholder="请选择处理结果" prop="reason">
          <el-input type="textarea" v-model="ruleOperForm.reason" style="width:352px;" :rows="5"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleOperForm',setStatus)">确认</el-button>
          <el-button @click="resetItemForm('ruleOperForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinOrgan,mixinFormatter],
  data() {
    return {
      formInline: {
        // user_name: '',
        // name: '',
        // structure_1: '',
        // major: '',
        training_room: '',
        check_status: '',
      },
      detailDialogVisible: false,
      rowObj: {},
      levell: [1, 2],
      organLabel: '',
      detailDialogVisible: false,
      eqs: [],
      rowObj: [],
      scraps: [{ isid: '1', ismc: '普通' }],
      total: 40,
      ruleForm: {
        training_room_id: '',
        order_start: '',
        order_end: '',
        reason: '',
        items: [],
      },
      listArr: [],
      remainder_quantity: 0,
      rules: {
        training_room_id: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],
        order_start: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        order_end: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        reason: [{ required: true, message: '申请理由不能为空', trigger: 'blur' }],
      },
      rules1: {},
      ruleOperForm: {
        id: '',
        apply_status: '',
        reason: '',
      },
      operRules: {
        reason: [{ required: true, message: '理由不能为空', trigger: 'blur' }],
      },
      operDialogVisible: false,
    };
  },
  components: {},
  created() {},
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.$store.dispatch('getTarinMent', { type: 'all' });
    this.$store.dispatch('getTarinMent');
  },
  methods: {
    handleOper(id, status) {
      let str = '整改';
      if (status == 2) {
        str = '关闭';
      }
      this.confirmBox('warning', `此操作将${str}该随手拍申请，是否继续`, { id, check_status:status }, this.setStatus);
    },
    async setStatus(params) {
      let res = await this.$api.instance.interfaceServer(`api/safety_check/free/oper/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '处理成功！',
        });
        this.getList();
      }
    },
    handleDetailClick(row) {
      this.rowObj = row.trouble_info.source_info;
      this.detailDialogVisible = true;
    },
    async handleClassChange(e) {
      if (this.ruleForm.training_room_id) {
        let params = { training_room_id: this.ruleForm.training_room_id };
        params.page = 1;
        params.size = 9999;
        let res = await this.$api.instance.interfaceServer('api/training/common/room/device/list', 'get', params);
        if (res.code == 0 && res.data) {
          this.eqs = res.data.data;
        }
      } else {
        this.eq = [];
      }
    },
    onSubmit() {
      console.log('submit!');
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handleExport() {
      this.$message.info('导出中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteDeviceInto() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteDeviceScrap(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createDeviceInto() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.items = params.items.map((item) => {
        return {
          type: item.type,
          name: item.name,
          num: item.num,
          id: item.id,
        };
      });
      params.items = JSON.stringify(params.items);
      let res = await this.$api.instance.interfaceServer('api/open_reservation/apply/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/safety_check/free/my/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    resetForm(formName) {
      this.ruleForm.device_price = 0;
      this.remainder_quantity = 0;
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.type == 'add') {
          this.createDeviceInto();
          // }else if(this.type == 'edit'){
          //   this.updateJournalOfTearcher()
          // }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
/deep/.el-link {
  margin-right: 4px;
}
</style>
